
export const headerFunction=()=>{
  const LOQ8Obj=localStorage.getItem("LOQ8");
  const obj = JSON.parse(LOQ8Obj);
  return {
    "Content-Type": "application/json" ,
    "Authorization": `Bearer ${obj.accessToken}` ,
  };
}
